module.exports = __webpack_public_path__ + "media/application/images/ui/green-tick-b600292f0a70e005a80aa4a6b74fe2aa.png";